import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: t('footer.product'),
      links: [
        { label: t('footer.links.o1Pro'), href: '/' },
        { label: t('footer.links.features'), href: '/' },
        { label: t('footer.links.app'), href: '/support#app-downloads' },
      ],
    },
    {
      title: t('footer.support'),
      links: [
        { label: t('nav.support'), href: '/support' },
      ],
    },
    {
      title: t('footer.companyGroup'),
      links: [
        { label: t('footer.links.about'), href: '/about' },
      ],
    },
  ];

  return (
    <footer className="bg-black border-t border-gray-900 text-white py-16">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img
                src="/images/logo.png"
                alt="Wyndme Logo"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              {t('footer.companyName')}
            </p>
            <p className="text-gray-500 text-sm mt-4">
              {t('footer.company')}
            </p>
          </div>

          {footerLinks.map((section, index) => (
            <div key={index}>
              <h4 className="text-sm uppercase tracking-wider text-white font-semibold mb-4">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link.href}
                      className="text-gray-500 text-sm hover:text-brand-gold transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-600 text-sm">
            {t('footer.copyright', { year: currentYear })}
          </p>
          <div className="flex space-x-6">
            <Link to="/" className="text-gray-600 text-sm hover:text-gray-400 transition-colors">
              {t('nav.home')}
            </Link>
            <Link to="/support" className="text-gray-600 text-sm hover:text-gray-400 transition-colors">
              {t('nav.support')}
            </Link>
            <Link to="/about" className="text-gray-600 text-sm hover:text-gray-400 transition-colors">
              {t('nav.about')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
